/** @jsx jsx */
import { jsx } from '@emotion/react';
import { forwardRef, useRef } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

import { Cache } from '../cache';

import { Backdrop } from './backdrop';
import { useModal } from './use-modal';

function findNode(id) {
  const node = document.getElementById(id);
  if (node) return node;
  const element = document.createElement('div');
  element.id = id;
  document.body.appendChild(element);
  return element;
}

export const Modal = forwardRef(
  ({ align, children, onClose, onFadeOut, visible, ...rest }, ref) => {
    const defaultRef = useRef(null);
    const backdropRef = ref || defaultRef;
    const { backdropIsVisible, onBackdropFade, shouldRender } = useModal({ onFadeOut, visible });
    if (!shouldRender) return null;
    const element = findNode('ui-modal');
    return createPortal(
      <Backdrop
        {...rest}
        align={align}
        visible={backdropIsVisible}
        onClick={onClose}
        onFadeOut={onBackdropFade}
        ref={backdropRef}
      >
        <Cache disabled={visible}>{children}</Cache>
      </Backdrop>,
      element,
    );
  },
);

Modal.propTypes = {
  align: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func,
  onFadeOut: PropTypes.func,
  visible: PropTypes.bool.isRequired,
};
Modal.defaultProps = {
  align: null,
  children: null,
  onClose: null,
  onFadeOut: null,
};
